import * as React from "react";
import { MapPin, Phone, Smartphone, Map } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const locations = [{
  id: 1,
  name: "London Hub",
  address: "Level 24, The Shard, 32 London Bridge St, London SE1 9SG, UK",
  phone: "+44 20 7946 0123",
  whatsapp: "+44 7700 900123",
  mapUrl: "https://maps.google.com/?q=The+Shard+London",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648747/img/global_hub_london.png"
}, {
  id: 2,
  name: "Singapore Office",
  address: "8 Marina View, Asia Square Tower 1, Singapore 018960",
  phone: "+65 6712 3456",
  whatsapp: "+65 9123 4567",
  mapUrl: "https://maps.google.com/?q=Asia+Square+Tower+Singapore",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648747/img/global_hub_singapore.png"
}, {
  id: 3,
  name: "New York Center",
  address: "One World Trade Center, 285 Fulton St, New York, NY 10007",
  phone: "+1 212 555 0198",
  whatsapp: "+1 917 555 0198",
  mapUrl: "https://maps.google.com/?q=One+World+Trade+Center+New+York",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648747/img/global_hub_new_york.png"
}];
export default function OurStores() {
  return;
}